module.exports = __webpack_public_path__ + "static/media/sabbose.5324ac84.svg";